import { HelpCaption } from './capations/help-caption';
import { SupportTitle } from './capations/support-title';

export const HelpCenterNotFound = () => {
  return (
    <>
      <SupportTitle />
      <HelpCaption>Videos are coming soon</HelpCaption>
    </>
  );
};
